import classNames from 'classnames';
import './pagination.css';
import {usePagination} from '../../hooks/pagination.hook';

export interface PaginationProps {
  initialOffset?: number;
  offset?: number;
  total: number;
  limit: number;
  siblings?: number;
  boundaries?: number;
  onChange?: (offset: number) => void;
  disabled?: boolean;
}

export default function Pagination(props: PaginationProps) {
  const {offset, total, limit, onChange, disabled} = props;

  const siblings = props.siblings ?? 1;
  const boundaries = props.boundaries ?? 2;
  const initialOffset = props.initialOffset ?? 0;

  const {range, setOffset, next, previous, active} = usePagination({
    offset,
    siblings,
    total,
    limit,
    onChange,
    initialOffset,
    boundaries,
  });

  if (total <= 0) {
    return null;
  }

  const items = range.map((offsetValue, index) => (
    <button
      className={classNames(
        'pagination-button',
        offsetValue === active ? 'active' : offsetValue !== 'dots' ? 'normal' : 'dots'
      )}
      key={index}
      disabled={disabled}
      onClick={offsetValue !== 'dots' ? () => setOffset(offsetValue) : undefined}
    >
      {offsetValue === 'dots' ? '...' : Math.floor(offsetValue / limit) + 1}
    </button>
  ));

  return (
    <div className='pagination-container'>
      <button
        disabled={active === 0 || disabled}
        onClick={previous}
        className={classNames('pagination-button', 'prev-next', {
          disabled: active === 0 || disabled,
        })}
      >
        {'Previous'}
      </button>

      {items}

      <button
        disabled={active + limit >= total || disabled}
        onClick={next}
        className={classNames('pagination-button', 'prev-next', {
          disabled: active + limit >= total || disabled,
        })}
      >
        {'Next'}
      </button>
    </div>
  );
}
